/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/file-chart-column
 */
import { default as DefaultIcon } from '~icons/lucide/file-chart-column';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const FileChartColumnIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
